export enum OrderType {
	loose = 'loose',
	classic = 'classic',
	own = 'own',
	other = 'other',
}
